import { FC, useEffect } from 'react';

import { Text, VSpacing, VSpacingContainer } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { ADFOX_PLACEMENTS, AdfoxPlacement, isPromoPlacement } from 'components/Admin/AdfoxInfo/adfoxInfoModel';
import { AdfoxInfoResult } from 'components/Admin/AdfoxInfo/AdfoxInfoResult/AdfoxInfoResult';
import { PromoFields } from 'components/Admin/AdfoxInfo/PromoFields/PromoFields';
import { RadioGroup } from 'components/Admin/AdfoxInfo/RadioGroup/RadioGroup';
import { TapTargetSelect } from 'components/Admin/AdfoxInfo/TapTargetSelect/TapTargetSelect';

import { resetAdfoxInfoForm, setAdfoxInfoPlacement } from 'store/models/adfoxInfo';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    title: 'admin.adfoxInfo.title',
    description: 'admin.adfoxInfo.description',
    placementTitle: 'admin.adfoxInfo.placement.title',
    placement: {
        [AdfoxPlacement.VacancyPage]: 'admin.adfoxInfo.placement.vacancyPage',
        [AdfoxPlacement.ResponseSuccess]: 'admin.adfoxInfo.placement.responseSuccess',
        [AdfoxPlacement.Profile]: 'admin.adfoxInfo.placement.profile',
        [AdfoxPlacement.Shifts]: 'admin.adfoxInfo.placement.shifts',
        [AdfoxPlacement.Main]: 'admin.adfoxInfo.placement.main',
        [AdfoxPlacement.HalfScreen]: 'admin.adfoxInfo.placement.halfScreen',
        [AdfoxPlacement.FullScreen]: 'admin.adfoxInfo.placement.fullScreen',
    },
};

export const AdfoxInfo: FC = () => {
    const placement = useSelector((state) => state.adfoxInfo.placement);

    const trls = useTrls();
    const dispatch = useDispatch();

    useEffect(
        () => () => {
            dispatch(resetAdfoxInfoForm(null));
        },
        [dispatch]
    );

    return (
        <>
            <Text typography="title-2-semibold">{trls(TrlKeys.title)}</Text>
            <VSpacing default={8} />
            <Text style="secondary">{trls(TrlKeys.description)}</Text>
            <VSpacing default={24} />
            <VSpacingContainer default={24}>
                <RadioGroup
                    title={trls(TrlKeys.placementTitle)}
                    name="adfox-info-placement"
                    options={ADFOX_PLACEMENTS}
                    value={placement}
                    labels={TrlKeys.placement}
                    dataQaPrefix="adfox-info-placement"
                    onChange={(value) => dispatch(setAdfoxInfoPlacement(value))}
                />
                {isPromoPlacement(placement) ? <PromoFields /> : <TapTargetSelect />}
            </VSpacingContainer>
            <VSpacing default={44} />
            <AdfoxInfoResult />
            <VSpacing default={24} />
        </>
    );
};
